import { Sidebar } from '@consta/uikit/Sidebar';
import React, { useCallback } from 'react';
import styles from './styles.styl';
export interface IComponentProps {
  isOpen: boolean;
  setSidebarOpen: (value: boolean) => void;
  selectRow: string;
  setSelectRow: (value?: string) => void;
  sidebarItemDetails: ISidebarItemDetails;
}
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { JournalMethodsEnum, TitleForColumnsTableEnum } from 'src/utils/enum';
import {
  IJournalItem,
  IJournalMethodsBackend,
} from 'src/redux/features/journal/types';
import { formatDateTime } from 'src/utils';
import { isMatch } from 'date-fns';
import { formatIsoFns } from 'src/utils/config';

const cx = cn.bind(styles);

export interface ISidebarItemDetails {
  methodDetails: IJournalMethodsBackend;
  commonInfo: IJournalItem;
}

const SidebarJournal: React.FC<IComponentProps> = ({
  isOpen,
  setSidebarOpen,
  setSelectRow,
  sidebarItemDetails,
}) => {
  const checkDate = useCallback((value: any) => {
    if (typeof value === 'string' && isMatch(value, formatIsoFns)) {
      return formatDateTime(value);
    }
    return value;
  }, []);

  const dataM2M = (data: any) => {
    if (!data) {
      return '';
    }
    return (
      <div className={cx('Journal__m2m')}>
        <Text className={cx('Journal__m2mTitle')} view="secondary">
          {'Данные M2M'}
        </Text>
        {Object.keys(data).map((dataM2MKey) => {
          if (typeof data[dataM2MKey] === 'object') {
            return (
              <div className={cx('Journal__sidebarItemDetailsWoPadding')}>
                <Text className={cx('Journal__dataM2MKey')}>{dataM2MKey}</Text>
                <div className={cx('Journal__sidebarItemDetailsWoPadding')}>
                  {Object.keys(data[dataM2MKey]).map((newDataM2MKey, index) => (
                    <div
                      key={`${index}${newDataM2MKey}`}
                      className={cx('Journal__sidebarItem')}
                    >
                      <Text size="xs" view="secondary">
                        {newDataM2MKey}
                      </Text>
                      <Text>{checkDate(data[dataM2MKey][newDataM2MKey])}</Text>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
        })}
      </div>
    );
  };

  return (
    <Sidebar
      isOpen={isOpen}
      onClickOutside={() => {
        setSidebarOpen(false);
        setSelectRow(undefined);
      }}
      hasOverlay={false}
      size="l"
    >
      {sidebarItemDetails && (
        <>
          <Sidebar.Content className={cx('Journal__sidebarItemDetails')}>
            <div className={cx('Journal__sidebarHeaderContainer')}>
              <div className={cx('Journal__sidebarHeader')}>
                <div className={cx('Journal__sidebarItem')}>
                  <Text view="primary">
                    {sidebarItemDetails?.commonInfo?.event}
                  </Text>
                </div>
                <IconClose
                  size="s"
                  className={cx('Journal__sidebarClose')}
                  onClick={() => {
                    setSidebarOpen(false);
                    setSelectRow(undefined);
                  }}
                />
              </div>
            </div>
            <div className={cx('Journal__sidebarItemDetailsWoPadding')}>
              <div className={cx('Journal__sidebarItem')}>
                <Text size="s" view="secondary">
                  {TitleForColumnsTableEnum.Ip}
                </Text>
                <Text size="s">
                  {sidebarItemDetails?.commonInfo.ip_address}
                </Text>
              </div>
              <div className={cx('Journal__sidebarItem')}>
                <Text size="s" view="secondary">
                  {TitleForColumnsTableEnum.Login}
                </Text>
                <Text size="s">
                  {sidebarItemDetails?.commonInfo?.user?.username}
                </Text>
              </div>
              <div className={cx('Journal__sidebarItem')}>
                <Text size="s" view="secondary">
                  {TitleForColumnsTableEnum.eventDate}
                </Text>
                <Text size="s">
                  {sidebarItemDetails?.commonInfo?.created_at}
                </Text>
              </div>
              <div className={cx('Journal__sidebarItem')}>
                <Text size="s" view="secondary">
                  {TitleForColumnsTableEnum.Service}
                </Text>
                <Text size="s">{sidebarItemDetails?.commonInfo?.service}</Text>
              </div>
            </div>
            {sidebarItemDetails?.methodDetails?.items?.length > 0 &&
              sidebarItemDetails?.methodDetails?.items.map((item) => (
                <div
                  className={cx('Journal__contentMethodDetailes')}
                  key={item.id}
                >
                  <div className={cx('Journal__sidebarItemDetailsWoPadding')}>
                    <div className={cx('Journal__sidebarItem')}>
                      <Text size="s" view="secondary">
                        {'id'}
                      </Text>
                      <Text size="s">{item.audit_id}</Text>
                    </div>
                    <div className={cx('Journal__sidebarItem')}>
                      <Text size="s" view="secondary">
                        {'Таблица'}
                      </Text>
                      <Text size="s">{item.table}</Text>
                    </div>
                    <div className={cx('Journal__sidebarItem')}>
                      <Text size="s" view="secondary">
                        {'Метод'}
                      </Text>
                      <Text size="s">{item.method}</Text>
                    </div>
                  </div>
                  {(item.method === JournalMethodsEnum.UPDATE ||
                    item.method === JournalMethodsEnum.INSERT) && (
                    <div
                      className={cx(
                        'Journal__sidebarItemDetailsWoPadding',
                        'Journal__update',
                      )}
                    >
                      {Object.keys(item.data_changed).map((change, index) => (
                        <div
                          className={cx('Journal__sidebarItem')}
                          key={`${index}${change}`}
                        >
                          <Text size="xs" view="secondary">
                            {change}
                          </Text>
                          {!!item?.data_old && !!item?.data_old[change] && (
                            <Text
                              size="s"
                              className={cx('Journal__lineThrough')}
                              view={'secondary'}
                            >
                              {checkDate(item.data_old[change])}
                            </Text>
                          )}
                          <Text size="s">
                            {checkDate(item.data_changed[change]) || '–'}
                          </Text>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.method === JournalMethodsEnum.DELETE && (
                    <div
                      className={cx(
                        'Journal__sidebarItemDetailsWoPadding',
                        'Journal__update',
                      )}
                    >
                      {Object.keys(item.data_old).map((change, index) => (
                        <div
                          className={cx('Journal__sidebarItem')}
                          key={`${index}${change}`}
                        >
                          <Text size="xs" view="secondary">
                            {change}
                          </Text>
                          <Text
                            size="s"
                            className={cx('Journal__lineThrough')}
                            view={'secondary'}
                          >
                            {checkDate(item.data_old[change])}
                          </Text>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.method === JournalMethodsEnum.SELECT && (
                    <div
                      className={cx(
                        'Journal__sidebarItemDetailsWoPadding',
                        'Journal__update',
                      )}
                    >
                      {Object.keys(item.data_old).map((old, index) => (
                        <div
                          className={cx('Journal__sidebarItem')}
                          key={`${index}${old}`}
                        >
                          <Text size="xs" view="secondary">
                            {old}
                          </Text>
                          <Text size="s">
                            {checkDate(item.data_old[old]) || '–'}
                          </Text>
                        </div>
                      ))}
                    </div>
                  )}
                  {(item.method === JournalMethodsEnum.BULK_REPLACE ||
                    item.method === JournalMethodsEnum.APPEND) &&
                    dataM2M(item?.data_m2m)}
                </div>
              ))}
          </Sidebar.Content>
        </>
      )}
    </Sidebar>
  );
};

export default SidebarJournal;
